import { VideosService } from "@/types/services/videos";

const videosBank = require.context("@/assets/videos/", false, /\.*$/);
export const videosService: VideosService = {
  get: (fileName: string) => videosBank(`./${fileName}`),
};
